import React from 'react';
import { FaCog } from 'react-icons/fa';
import { useAuth } from '../../context/AuthContext';
import { safeText } from '../../utils/sanitize';

export default function AuthBar({ onOpenAuth, onOpenAdmin }) {
  const { user, logout, loading } = useAuth();
  if (loading) return <div className="auth-bar" />;

  return (
    <div className="auth-bar">
      {user ? (
        <>
          <span className="username">
            {safeText(user.username)}
            {user.role === 'admin' && <span className="role-badge">ADMIN</span>}
          </span>
          {user.role === 'admin' && (
            <button
              className="btn btn-sm icon-btn"
              onClick={onOpenAdmin}
              title="Admin panel"
              aria-label="Admin panel"
            >
              <FaCog />
            </button>
          )}
          <button className="btn btn-sm" onClick={logout}>Logout</button>
        </>
      ) : (
        <>
          <button className="btn btn-sm" onClick={() => onOpenAuth('login')}>Login</button>
          <button className="btn btn-sm btn-primary" onClick={() => onOpenAuth('register')}>Register</button>
        </>
      )}
    </div>
  );
}
